module.exports = {"assets":[{"name":"bill","url":"assets/sprites/sprite.png","type":"image"},{"name":"trump-bill","url":"assets/images/trump-bill.png","type":"image"},{"name":"political-joey","url":"assets/images/political-joey.jpg","type":"image"},{"name":"spray","url":"assets/sprites/spray-bw.png","type":"image"}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/assets.json
// module id = 361
// module chunks = 0